import i18n from '@/utils/i18n';
import React from 'react';
import { PAGE_CONTAINER_PADDING_HORIZONTAL } from './utils';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

interface Props {
  containerStyle?: StyleProp<ViewStyle>;
}

export const InboundListScreenHeader: React.FC<Props> = ({
  containerStyle,
}) => {
  return (
    <View style={[styles.titleWrapper, containerStyle]}>
      <Typography variant="heading-xl">{i18n.t('order_inbounds')}</Typography>
    </View>
  );
};

const styles = StyleSheet.create({
  titleWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: PAGE_CONTAINER_PADDING_HORIZONTAL,
    paddingVertical: 8,
  },
});
